import { useEffect } from 'react';
import { NativeEventEmitter, NativeModules } from 'react-native';
import { atom, getDefaultStore } from 'jotai';
import { isWeb } from '../utils';

type ForegroundState = Record<string, boolean>;

export const foregroundAtom = atom<ForegroundState>({});

/**
 * viewDidAppear / viewDidDisappear 이벤트에 대해 싱글 listener를 등록하고,
 * instanceId별 foreground 상태를 jotai atom에 기록합니다.
 * App.tsx에 배치하세요. null을 반환하므로 리렌더를 유발하지 않습니다.
 */
export const ForegroundProvider = () => {
  useEffect(() => {
    if (isWeb) return;

    const emitter = new NativeEventEmitter(NativeModules.ReactNativeBridge);
    const store = getDefaultStore();

    const appearSub = emitter.addListener(
      'viewDidAppear',
      (data: { instanceId: string }) => {
        store.set(foregroundAtom, prev => ({
          ...prev,
          [data.instanceId]: true,
        }));
      },
    );

    const disappearSub = emitter.addListener(
      'viewDidDisappear',
      (data: { instanceId: string }) => {
        store.set(foregroundAtom, prev => ({
          ...prev,
          [data.instanceId]: false,
        }));
      },
    );

    return () => {
      appearSub.remove();
      disappearSub.remove();
    };
  }, []);

  return null;
};
